import { RawNode, ProxyRaw } from './environment';
import { isFn } from './checkers';
export var observe = function (target, observer, deep) {
    if (deep === void 0) { deep = true; }
    var listener = function (change) {
        if (isFn(observer)) {
            observer(change);
        }
    };
    var addListener = function (target) {
        var raw = ProxyRaw.get(target) || target;
        var node = RawNode.get(raw);
        if (node) {
            if (deep) {
                var id_1 = node.deepObservers.length;
                node.deepObservers.push(listener);
                listener.unobserve = function () {
                    node.deepObservers.splice(id_1, 1);
                };
            }
            else {
                var id_2 = node.observers.length;
                node.observers.push(listener);
                listener.unobserve = function () {
                    node.observers.splice(id_2, 1);
                };
            }
        }
        return function () {
            listener === null || listener === void 0 ? void 0 : listener.unobserve();
        };
    };
    if (target && typeof target !== 'object')
        throw Error("Can not observe " + typeof target + " type.");
    return addListener(target);
};
